import { useState } from 'react';
import { Outlet } from 'react-router';
import { IconButton } from '@astryxdesign/core/IconButton';
import { Sparkle } from '@phosphor-icons/react';
import { BottomNav, clientNav } from '../../components/BottomNav';
import { useTenant } from '../../app/tenant-context';
import { AssistantSheet } from './AssistantSheet';

export function ClientLayout() {
  const { base, sf } = useTenant();
  const [assistant, setAssistant] = useState(false);
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only">К содержимому</a>
      <main id="main" className="with-bottom-nav">
        <Outlet context={{ openAssistant: () => setAssistant(true) }} />
      </main>
      {sf.profile.assistant_enabled ? (
        <div style={{ position: 'fixed', right: 16, bottom: 'calc(92px + env(safe-area-inset-bottom))', zIndex: 39 }}>
          <IconButton label="Помощник: спросите про время и цены" icon={<Sparkle size={22} weight="fill" />} variant="primary" size="lg"
            elevation="high" onClick={() => setAssistant(true)} />
        </div>
      ) : null}
      <BottomNav items={clientNav(base)} label="Разделы" />
      <AssistantSheet open={assistant} onClose={() => setAssistant(false)} mode="client" />
    </>
  );
}

export interface ClientOutletContext { openAssistant: () => void }
